import axiosClient from './axiosClient';
export default {
  register: (data) => axiosClient.post('/precampagna/register', data),
  list: (params) =>
    axiosClient.get('/precampagna/lista',{ params }),
};